export default () => ({
    chrome: '22',
    ie: '9',
    firefox: '27',
    safari: '7',
});
